<section class="padding-30px-tb xs-padding-60px-tb blog-style1 bg-light-deep-yellow header-margin-top-medium" id="">
  <div class="container">
    <!-- title -->
    <!-- title -->
    <h2
      class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom text-center">
      Propiedades Rurales </h2>
    <div class="row margin-three">
      <form [formGroup]="filtrarForm" action="" method="post">
        <ng-multiselect-dropdown class="medium-input border-radius-4 float-left width-20 md-width-90 margin-one-right"
          [placeholder]="'Elegir departamento...'" [data]="departamentoList" formControlName="valor"
          [settings]="dropdownSettings" (onSelect)="onDepartamentoSelect($event)"
          (onDeSelect)="onDepartamentoDeSelect($event)" (onSelectAll)="onDepartamentoSelectAll($event)"
          (onDeSelectAll)="onDepartamentoSelectAll($event)">
        </ng-multiselect-dropdown>
      </form>
    </div>
    <!-- end  title -->
    <div class="row row-propiedades margin-two-top">
      <!-- item -->
      <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-nineteen-bottom" *ngFor="let propiedad of propiedades">
        <div class="item-post">
          <h3 class="text-large text-center text-white bg-dark-brown font-weight-600">Propiedad N&deg; {{
                propiedad.numero_referencia }}</h3>
          <!-- image -->
          <div class="item-image">
            <a [routerLink]="['/propiedades-rurales', propiedad.id]" routerLinkActive="active" class=""><img
                *ngIf="propiedad.imagenes.length > 0" class="" alt="" src="{{ propiedad.imagenes[0].url }}"
                data-img-size="(W)800px X (H)507px"></a> </div>
          <!-- end image -->
          <!-- details -->
          <div class="bg-white  padding-10px-tb">
            <div class="text-medium xs-text-large font-weight-800 text-center padding-seven">
              <h3 class="text-center title-small xs-title-medium text-dark-brown font-weight-600">{{
                        propiedad.localidad }}</h3>
              <span class="width-100">ZONA: {{propiedad.zona}} </span><br>
              <span class="width-100">CANTIDAD HAS: {{ propiedad.cantidad_hectareas }} | PRECIO:
                {{ separadorMiles(propiedad.precio | currency : 'Gs.':'symbol':'3.0-0') }}</span><br>
              <span class="width-100">DESCRIPCION: {{ propiedad.descripcion }}</span><br>
            </div>
            <div class="btn-dual text-center margin-five">
              <a class="btn btn-large propClone btn-circle bg-deep-green text-white inner-link"
                [routerLink]="['/propiedades-rurales',propiedad.id]" routerLinkActive="active"><span class="" id="">VER
                  PROPIEDAD</span></a>
            </div>
          </div>
          <!-- end details -->
        </div>
      </div>
      <!-- end item -->
    </div>
  </div>
</section>
<section class="padding-50px-tb bg-light-deep-yellow  xs-padding-60px-tb feature-style-31 border-none" id="">
  <div class="separator-line1 width-80 bg-dark-brown center-col  margin-five-bottom sm-margin-ten-bottom"></div>
  <div class="container">
    <div class="row">
      <!-- feature box -->
      <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
        <div class=" display-table width-100">
          <a routerLink="/como-funciona" routerLinkActive="active">
            <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle"><span
                class="fas fa-info-circle title-extra-large-2 "></span></div>
            <div class="display-table-cell-vertical-middle ">
              <span class="text-medium text-medium-gray ">Información</span>
              <h3 class="text-large alt-font text-dark-gray ">Como funciona</h3>
            </div>
          </a>
        </div>
      </div>
      <!-- end feature box -->
      <!-- feature box -->
      <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
        <div class=" display-table width-100">
          <a routerLink="/condiciones-subasta" routerLinkActive="active">
            <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle"><span
                class="fas fa-gavel title-extra-large-2 "></span></div>
            <div class="display-table-cell-vertical-middle ">
              <span class="text-medium text-medium-gray ">Participar de subastas</span>
              <h3 class="text-large alt-font text-dark-gray ">Condiciones</h3>
            </div>
          </a>
        </div>
      </div>
      <!-- end feature box -->
      <!-- feature box -->
      <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
        <div class=" display-table width-100">
          <a routerLink="/login" routerLinkActive="active">
            <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle"><span
                class="fas fa-address-card title-extra-large-2 "></span></div>
            <div class="display-table-cell-vertical-middle ">
              <span class="text-medium text-medium-gray ">Únase hoy mismo</span>
              <h3 class="text-large alt-font text-dark-gray ">Registro</h3>
            </div>
          </a>
        </div>
      </div>
      <!-- end feature box -->
      <!-- feature box -->
      <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
        <div class=" display-table width-100">
          <a routerLink="/login" routerLinkActive="active">
            <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle"><span
                class="fas fa-sign-in-alt title-extra-large-2 "></span></div>
            <div class="display-table-cell-vertical-middle ">
              <span class="text-medium text-medium-gray ">¿Ya está registrado?</span>
              <h3 class="text-large alt-font text-dark-gray ">Ingresar</h3>
            </div>
          </a>
        </div>
      </div>
      <!-- end feature box -->
    </div>
  </div>
</section>